import { VAlert } from 'vuetify/lib/components/VAlert';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VForm } from 'vuetify/lib/components/VForm';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('core-n20-dialog', {
    attrs: {
      "isOpen": _vm.isOpen,
      "max-width": "900"
    },
    on: {
      "close": function ($event) {
        return _vm.$emit('close');
      }
    },
    scopedSlots: _vm._u([{
      key: "title",
      fn: function () {
        return [_vm._v("\n    " + _vm._s(_vm.title) + "\n  ")];
      },
      proxy: true
    }, {
      key: "buttons",
      fn: function () {
        return [_vm.editedItem.applicationId ? _c('core-button', {
          attrs: {
            "color": _vm.color,
            "title": _vm.$i18n_t('Common.reset'),
            "prepend-icon": "fa-arrow-left"
          },
          on: {
            "click": function ($event) {
              return _vm.goBack();
            }
          }
        }) : _vm._e(), _c('niota-classic-common-account-filter', {
          attrs: {
            "multiple": "",
            "n1Accounts": ""
          },
          on: {
            "selected": accounts => {
              _vm.accountIds = accounts.map(a => a.id);
            },
            "reset-filter": _vm.resetFilter
          }
        })];
      },
      proxy: true
    }])
  }, [_c(VContainer, {
    staticClass: "pa-0 item-selector",
    attrs: {
      "fluid": ""
    }
  }, [_c(VForm, {
    ref: "form"
  }, [_c(VRow, [_c(VCol, {
    staticClass: "pb-0"
  }, [_c(VTextField, {
    attrs: {
      "color": _vm.color,
      "label": _vm.$i18n_t('Common.search'),
      "outlined": _vm.inpOutlined,
      "filled": _vm.inpFilled,
      "append-icon": "fal fa-search",
      "hide-details": "auto",
      "single-line": "",
      "clearable": ""
    },
    model: {
      value: _vm.searchItem,
      callback: function ($$v) {
        _vm.searchItem = $$v;
      },
      expression: "searchItem"
    }
  })], 1)], 1), _c(VDivider), _c(VDataTable, {
    staticClass: "row-pointer",
    attrs: {
      "items": _vm.list,
      "headers": _vm.headers,
      "loading": _vm.isFetching,
      "server-items-length": _vm.serverItemsLength,
      "options": _vm.tableOptions,
      "footer-props": _vm.tableFooterProps,
      "item-key": "id"
    },
    on: {
      "update:options": function ($event) {
        _vm.tableOptions = $event;
      }
    },
    scopedSlots: _vm._u([{
      key: "item",
      fn: function (items) {
        return [_c('tr', {
          style: _vm.rowStyle(items.item),
          on: {
            "click": function ($event) {
              return _vm.handleClickRow(items.item);
            }
          }
        }, [_c('td', [_vm._v(_vm._s(items.item.id))]), _c('td', [!items.item.image && items.item.datasource && items.item.datasource.image ? _c('img', {
          staticClass: "icon",
          attrs: {
            "src": _vm.niota1ImageUrl(items.item.datasource.image)
          }
        }) : _vm._e(), items.item.image ? _c('img', {
          staticClass: "icon",
          attrs: {
            "src": _vm.niota1ImageUrl(items.item.image)
          }
        }) : _vm._e()]), items.item.type ? _c('td', [_vm._v(_vm._s(items.item.type))]) : _vm._e(), _c('td', [_vm._v(_vm._s(items.item.title))]), _c('td', [_c('div', {
          staticClass: "text-truncate",
          staticStyle: {
            "max-width": "200px"
          }
        }, [_vm._v(_vm._s(items.item.description))])]), _c('td', [_vm._v(_vm._s(_vm.localizeDate(items.item.createdAt)))])])];
      }
    }, {
      key: "no-data",
      fn: function () {
        return [_c(VAlert, {
          staticClass: "mb-1",
          attrs: {
            "value": true,
            "color": "transparent",
            "icon": "fal fa-comment-exclamation"
          }
        }, [_vm._v("\n            " + _vm._s(_vm.$i18n_t('Common.SorryNothingToDisplay')) + "\n          ")])];
      },
      proxy: true
    }])
  })], 1)], 1)], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };